import RetentionActionType from 'owa-service/lib/contract/RetentionActionType';
import {
    ActiveRetentionPolicyRowType,
    AvailableRetentionPolicyRowType,
} from '../store/schema/RetentionPolicyRowType';
import RetentionPolicyTag from 'owa-service/lib/contract/RetentionPolicyTag';

export default function createNewRetentionPolicyTag(
    retentionPolicyRow: ActiveRetentionPolicyRowType | AvailableRetentionPolicyRowType,
    isVisible: boolean
): RetentionPolicyTag {
    const {
        RetentionId,
        DisplayName,
        AgeLimitForRetentionDays,
        Type,
        RetentionAction,
        OptionalTag,
        Description,
    } = retentionPolicyRow;
    return {
        RetentionId: RetentionId,
        DisplayName: DisplayName,
        RetentionPeriod: AgeLimitForRetentionDays,
        Type: Type,
        RetentionAction: RetentionAction,
        IsVisible: isVisible,
        OptedInto: OptionalTag,
        Description: Description,
        IsArchive: RetentionAction === RetentionActionType.MoveToArchive,
    };
}
